import React from 'react';

// Style
import 'components/Carts/CartChemicalProbes/CartChemicalProbes.scss';
import 'components/Carts/CartPfizer/CartPfizer.scss';

// Redux
import { Link } from 'react-router-dom';

// Components
import Img from 'components/Img';
import DropdownPrice from 'components/DropdownPrice';
import CountControll from 'components/CountControll';
import FieldCheckbox from 'components/UiKit/FieldCheckbox';

// Constants
import config from 'lib/config';

export const DataCartItem = (props: any) => {
	const {
		id,
		to,
		cas,
		name,
		isPOA,
		onStock,
		selected,
		titlePOA,
		quantity,
		numeration,
		currentPrice,
		handleClickPlus,
		handleClickMinus,
		convertedOptions,
		currentTypePrice,
		optionsTypePrices,
		handleChangePrices,
		handleChangeCheckbox,
		handleChangeTypePrice,
	} = props;
	const src = `${config.api.apiUrl}ebc/catalog/${id}/image?format=png:-a,w430,h206,noantialias,H_hetero`;

	const labelStoke = onStock ? 'In Stock' : 'Out of<br />Stock';
	const innerTitleClass = onStock ? 'pfizer-cart__dropdown-price--in-stock' : 'pfizer-cart__dropdown-price--out-of-stock';
	
	return <div className="pfizer-cart relative flex flex-jc-between flex-direction-column">
		<FieldCheckbox
			readOnly
			label={numeration}
			value={onStock && selected}
			disabled={!onStock || isPOA}
			name="checkboxItemCartPfizer"
			className="pfizer-cart__checkbox"
			onChange={handleChangeCheckbox(id || '')}
		/>

		<Img
			alt={id}
			isPreloader
			innerSrc={src}
			className="pfizer-cart__img display-none-mobile"
			classNameWrapper="flex flex-ai-center flex-jc-center"
			classNameImgSvg="pfizer-cart__img display-none-mobile"
		/>

		<div>
			<Link to={to} className="pfizer-cart__id">
				{id}
			</Link>

			<p className="pfizer-cart__cas mb10 mt10">
				<span>CAS:</span>{cas}
			</p>

			{!!name && <div
				className="pfizer-cart__name mb10"
				dangerouslySetInnerHTML={{ __html: name || '' }}
			/>}

			<div className="pfizer-cart__dropdown-price-wrapper flex flex-ai-center">
				<DropdownPrice
					titlePOA={titlePOA}
					withUrlParam={false}
					innerTitle={labelStoke}
					options={convertedOptions}
					currentPrice={currentPrice}
					typePrice={currentTypePrice}
					onChange={handleChangePrices}
					optionsRadio={optionsTypePrices}
					innerTitleClass={innerTitleClass}
					className="pfizer-cart__dropdown-price mr5"
					handlerChangeTypePrice={handleChangeTypePrice}
				/>

				<CountControll
					isCart
					isHideTitle
					innerCount={quantity}
					className="flex-jc-end"
					innderDisabled={!selected}
					handlerPlus={handleClickPlus}
					handlerMinus={handleClickMinus}
				/>
			</div>
		</div>
	</div>;
};

export default DataCartItem;